// extracted by mini-css-extract-plugin
module.exports = {"hotspot":"rgbCircle_hotspot__NNA7J","hotspotActive":"rgbCircle_hotspotActive__ti4iR","hotspotMobile":"rgbCircle_hotspotMobile__W3ykK"};